module.exports = __webpack_public_path__ + "static/condo_prevApplication-6be38499b5968d1eef26ca871a775674.jpg";